import * as ValidateModel from '../../shared/ValidateModel';
import { rgbToHex } from '@material-ui/core/styles';

class KapinuaColor {
    readonly id: number;

    readonly rgb: string;

    readonly hex: string;

    constructor(id: number, rgb: string) {
        ValidateModel.isNumber(id, 'id');
        ValidateModel.isString(rgb, 'rgb');

        this.id = id;
        this.rgb = rgb;
        this.hex = rgbToHex(rgb);
    }

    getId = (): number => this.id;

    getRgb = (): string => this.rgb;

    getHex = (): string => this.hex;
}

export default KapinuaColor;
